import React from 'react';

import { VideoListWrap } from './video-list-wrap';
import useTheme from '../../components/hooks/useTheme';

import './index.scss';
import '../common.scss';

export interface MultiVideoProps {
  cid: string;
  title: string;
  showTitle?: boolean;
  search: any;
  download: boolean;
  selectVideoSource: Array<string>;
  videos: Array<any>;
}

export const ComponentMultiVideoV2 = (props: MultiVideoProps | any) => {
  const theme = useTheme();
  const { title } = props;

  return (
    <div className="decoratev2-comp-com component-multi-video-v2">
      {title ? (
        <div className="row-wrapper">
          <div
            className="title"
            style={{ color: theme.h1Color }}
          >
            {title}
          </div>
        </div>
      ) : null}
      <VideoListWrap {...props} />
    </div>
  );
};
